exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wallet-bar-container[data-v-690aa2e8]{z-index:1;position:fixed;width:100%;height:48px;margin-top:-4px}.wallet-bar-content-container[data-v-690aa2e8]{position:absolute;top:0;left:0;right:0;bottom:0;margin:auto;width:70%;max-width:300px;height:100%}.wallet-bar[data-v-690aa2e8]{width:100%}.wallet-bar[data-v-690aa2e8],.wallet-name[data-v-690aa2e8]{position:absolute;top:0;left:0;right:0;bottom:0;margin:auto}.wallet-name[data-v-690aa2e8]{text-align:center;height:50%}.wallet-icon[data-v-690aa2e8]{position:absolute;top:0;bottom:0;right:32px;margin:auto;z-index:2}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-690aa2e8","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/parts/WalletBar.vue
// module id = 676
// module chunks = 1